import girderEvents from 'girder/events';

export default girderEvents;



// WEBPACK FOOTER //
// ./plugins/slicer_cli_web/web_client/events.js